import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA ,MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

@Component({
  selector: 'zoom-images',
  templateUrl: './zoom-images.component.html',
  styleUrls: ['./zoom-images.component.scss']
})
export class ZoomImagesComponent implements OnInit {
    images: any;
    index: any;
    leftBtn: any;
    rightBtn: any;
    leftImage: String =" /assets/images/less-than-icon.png"
    rightImage: String ="/assets/images/greater-than-icon.png";
    zoomInOut=0;

  constructor(public dialogRef: MatDialogRef<ZoomImagesComponent>, 
    @Inject(MAT_DIALOG_DATA) public productImages: any, private dialog: MatDialog) { }

  ngOnInit() {
    this.images=this.productImages.itemImages;
    for(let i=0;i<this.productImages.itemImagesUrl.length;i++){
      if(this.images === this.productImages.itemImagesUrl[i].img)
      this.index=i;
    }
   
   (this.index==0 )? this.leftBtn = false : this.leftBtn =true;
   this.rightBtn=(this.index==(this.productImages.itemImagesUrl.length-1)) ? false : true;
  }
  onPreviousClick(){
    this.rightBtn = true;
    this.index= ((this.index > 0 )|| (this.index == this.productImages.itemImagesUrl.length) )? this.index-1 : this.index
    this.images = this.productImages.itemImagesUrl[this.index].img
    if(this.index===0) 
    this.leftBtn = false;
  }
  onNextClick(){
    this.leftBtn = true;
    this.index= (this.index< this.productImages.itemImagesUrl.length) ? this.index +1 : this.index
    if(this.index===(this.productImages.itemImagesUrl.length-1)){
    this.images = this.productImages.itemImagesUrl[this.index].img ;
    this.rightBtn = false;
    }
    else
    this.images = this.productImages.itemImagesUrl[this.index].img 
  } 
  onClickImage(){
    this.zoomInOut=this.zoomInOut + 1;
    if(!(this.zoomInOut%2===0)){
    document.getElementById('pro-image').setAttribute("style", "zoom:2;");
    document.getElementById('product-image').setAttribute("style", "top:200px;align-content:center;");
    }
    else{
      document.getElementById('pro-image').setAttribute("style", "zoom:1;");
      document.getElementById('product-image').setAttribute("style", "top:10px;bottom:30px;");
  }
  }
  onClose() {
    this.dialogRef.close();
  }

}
